export default __webpack_public_path__ + "static/media/29.611042e5.png";